'use client';

// NODE PACKAGES
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
// REDUX
import {
	selectHostName,
	selectDocMode,
	selectInputSource,
} from '@/slices/commonSlice';
// REACT COMPONENTS
import FormattedMessage from '../FormattedMessage';
import AddPicturesButton from '../AddPicturesButton/AddPicturesButton';
import GooglePhotosButton from '../GooglePhotosButton/GooglePhotosButton';
import AddFacebookButton from '../AddFacebookButton/AddFacebookButton';
// STYLING
import CloudTransferStyle from './CloudTransfer.module.scss';

export default function CloudTransfer() {
	const docMode = useSelector(selectDocMode);
	const inputSources = useSelector(selectInputSource);
	const hostName = useSelector(selectHostName);

	const messageId = docMode ? 'upload-document-info' : 'upload-image-info';
	const imgSrc = docMode
		? './images/ill_doc-stack_160.svg'
		: './images/ill_print-stack_160.svg';

	const uploadButtons = useMemo(() => {
		if (inputSources && inputSources.length > 0) {
			return inputSources.map((platform) => {
				switch (platform) {
					case 'dt':
						return (
							<div
								className="upload-button-container"
								key={platform}
							>
								<AddPicturesButton docMode={docMode} />
							</div>
						);
					case 'fb':
						if (!docMode) {
							return (
								<div
									className="upload-button-container"
									key={platform}
								>
									<AddFacebookButton />
								</div>
							);
						}
						break;
					case 'gp':
						if (!docMode) {
							return (
								<div
									className="upload-button-container"
									key={platform}
								>
									<GooglePhotosButton />
								</div>
							);
						}
						break;
					default:
						console.error('Unknown platform', platform);
				}
			});
		}
		return null;
	}, [inputSources, docMode]);

	return (
		<div
			className={CloudTransferStyle['cloud-transfer-container']}
			style={{
				'--button-border-radius': hostName === 'ng' ? '100px' : 'unset',
			}}
		>
			<div className="landing-page-image">
				<img
					className="print-stack-image"
					src={imgSrc}
					alt="print-stack"
				/>
			</div>
			<div className="image-upload-info">
				<FormattedMessage id={messageId} />
			</div>
			<div className="upload-buttons">{uploadButtons}</div>
		</div>
	);
}
